import { types } from "./types";

export const UserReducer = (state, action) => {
  switch (action.type) {
  case types["[Login]"]:
    return { ...state, user: action.payload };

  case types["[Reselect]"]:
    return { ...state, user: action.payload };

  case types["[Logout]"]:
    return { ...state, user: null };

  default:
    return state;
  }
};
